// extracted by mini-css-extract-plugin
export default {"container":"iKQupwh sOoULa1 leavesden4","link":"KqC5x9Y sOoULa1 leavesden4"};